module.exports = __webpack_public_path__ + "static/media/AM.3f177416.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/AM.svg
// module id = 2098
// module chunks = 7